import { Route, Routes } from "react-router-dom";
import DeliveryCollectionCreateScreen from "screens/App/CRM/Payment/DeliveryCollection/DeliveryCollectionCreateScreen";
import DeliveryCollectionDetailScreen from "screens/App/CRM/Payment/DeliveryCollection/DeliveryCollectionDetailScreen";
import DeliveryCollectionListScreen from "screens/App/CRM/Payment/DeliveryCollection/DeliveryCollectionListScreen";

import { NotFoundScreen } from "screens/NotFoundScreen";
import DeliveryCollectionEditScreen from "screens/App/CRM/Payment/DeliveryCollection/DeliveryCollectionEditScreen";
import DeliveryCollectionShipmentCreateScreen from "screens/App/CRM/Payment/DeliveryCollection/DeliveryCollectionShipmentCreateScreen";

const DeliveryCollectionRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<DeliveryCollectionCreateScreen />} />
      <Route path="createByShipment" element={<DeliveryCollectionShipmentCreateScreen />} />
      <Route path=":id/detail" element={<DeliveryCollectionDetailScreen />} />
      <Route path="list" element={<DeliveryCollectionListScreen />} />
      <Route path=":id/edit" element={<DeliveryCollectionEditScreen />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default DeliveryCollectionRouter;
